// extracted by mini-css-extract-plugin
export default {"container":"LoadingSpinner_container__yi8bT","fullPage":"LoadingSpinner_fullPage__bqaDi","message":"LoadingSpinner_message__mhZ8f"};